package pl.decks.personal.components.animations

import com.varabyte.kobweb.compose.css.StyleVariable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.silk.style.animation.Keyframes

object AppearAnimation {
    object Vars {
        val fromOpacity by StyleVariable<Number>(0)
        val toOpacity by StyleVariable<Number>(1)
    }

    val Frames = Keyframes {
        from { Modifier.opacity(Vars.fromOpacity.value()) }
        to { Modifier.opacity(Vars.toOpacity.value()) }
    }
}
